export const SHARE_RESOURCE = '/share-resource'
export const MANAGE_RESOURCES = '/manage-my-resources'
export const MANAGE_RESOURCES_NAME = 'ManageMyResources'
export const PENDING_RESOURCES_NAME = 'PendingResources'
export const SHARE_LINK_NAME = 'Share'
export const HOME = '/'
export const MODERATE_RESOURCES_PATH = 'moderate-resources'
export const MODERATE_RESOURCE_PATH = 'moderate-resource'
export const NOTEBOOK_PATH = '/notebook'
export const ROUTE_NAME_SHARE = 'Share'
export const ROUTE_NAME_SEARCH = 'Search'
export const ROUTE_NAME_MYRESOURCE = 'MyResource'
export const ROUTE_NAME_HOME = 'Home'
export const ROUTE_NAME_MODERATE_RESOURCE = 'ModerateResource'
export const ROUTE_NAME_MODERATE_RESOURCES = 'ModerateResources'
export const ROUTE_NAME_MODERATE_RESOURCES_STATUS = 'ModerateResourcesAndStatus'
export const ROUTE_NAME_SHARE_RESOURCE = 'ShareResource'
export const ROUTE_NAME_PREVIEW = 'Preview'
export const LEGACY_SIGN_UP = 'LegacySignUp'
export const LEGACY_SIGN_IN = 'LegacySignIn'

// SMEX 1 Transition paths
export const LEGACY_PATHNAME_DETAILS = '/details.html'
export const LEGACY_PATHNAME_TRAINING = '/training.html'
export const LEGACY_PATHNAME_CURRICULUM = '/curriculum.html'
export const LEGACY_PATHNAME_SHARE = '/share.html'
export const LEGACY_PATHNAME_SEARCH = '/search.html'
export const LEGACY_PATHNAME_INDEX = '/index.html'
export const LEGACY_PATHNAME_TERMS = '/terms.html'
export const LEGACY_PATHNAME_LOGIN = '/login.html'
export const LEGACY_PATHNAME_REGISTER = '/register.html'
export const ROUTE_PATH_DETAILS_ERROR = '/error/details'
